import ExcelJS from "exceljs";

const applyCell = (cell, value, type) => {
  if (value === null || value === undefined || value === "") {
    cell.value = "";
    return;
  }

  if (type === "number") {
    const parsed = Number(value);
    cell.value = Number.isFinite(parsed) ? parsed : String(value);
    return;
  }

  if (type === "date") {
    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) {
      cell.value = date;
      cell.numFmt = "yyyy-mm-dd hh:mm";
      return;
    }
  }

  cell.value = String(value);
};

export const downloadListingsWorkbook = async ({ columns, rows }) => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Ghorfatech";
  const sheet = workbook.addWorksheet("Listings", {
    views: [{ state: "frozen", ySplit: 1 }],
  });

  sheet.columns = columns.map((column) => ({
    header: column.header,
    key: column.key,
    width: Math.min(42, Math.max(16, String(column.header).length + 2)),
  }));

  rows.forEach((row) => {
    const excelRow = sheet.addRow({});
    columns.forEach((column, index) => {
      applyCell(excelRow.getCell(index + 1), row[column.key], column.type);
    });
  });

  const header = sheet.getRow(1);
  header.font = { bold: true };
  header.alignment = { vertical: "middle" };
  if (columns.length) {
    sheet.autoFilter = {
      from: { row: 1, column: 1 },
      to: { row: 1, column: columns.length },
    };
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `listings-${new Date().toISOString().slice(0, 10)}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
